import React from 'react';
import Grid from '@material-ui/core/Grid';
import ImageUploader from 'react-images-upload'
import { TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import '../styles/ResponsiveStyle.css'

export default function DrivingLicenseInformation(props) {
    const msg = "This is a required field";

    const handleChange = (e, flag) => {
        if (flag === "driver_license_exp") {
            props.setError({
                ...props.error,
                [flag]: false
            })
            props.handleChange(e, flag)
        } else {
            props.setError({
                ...props.error,
                [e.target.name]: false
            })
            props.handleChange(e)
        }
    }

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Driver License (Front)"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "driving_license_front")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.driving_license_front.file !== undefined ? props.stepContent.driving_license_front.file.name : ""}</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Driver License (Back)"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "driving_license_back")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.driving_license_back.file !== undefined ? props.stepContent.driving_license_back.file.name : ""}</p>

                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        error={props.error.driver_license_no}
                        value={props.stepContent.driver_license_no}
                        onChange={handleChange}
                        id="driver_license_no"
                        name="driver_license_no"
                        label="Driving License No."
                        fullWidth
                        autoComplete="license"
                        helperText={props.error.driver_license_no ?
                            msg : ""
                        }
                        variant="outlined"
                    />

                </Grid>
                <Grid item xs={12} sm={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            autoOk
                            disablePast
                            variant="inline"
                            inputVariant="outlined"
                            label="License Expiry Date"
                            format="YYYY/MM/DD"
                            value={props.stepContent.driver_license_exp}
                            InputAdornmentProps={{ position: "start" }}
                            onChange={date => {
                                handleChange(date, "driver_license_exp")
                            }}
                            style={{ width: "100%" }}
                            required
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>
        </React.Fragment >
    );
}